import ACCESS from 'utils/Access'

const SUB_NAV_NODES = () => [
  {
    label: 'Chat playbooks',
    expanded: false,
    path: '/playbooks?category=chat',
  },
  {
    label: 'Email playbooks',
    expanded: false,
    path: '/playbooks?category=email',
  },
  {
    label: 'Signature playbooks',
    expanded: false,
    path: '/playbooks?category=signature',
  },
  {
    label: 'Drift automation',
    expanded: false,
    external: true,
    hide: !ACCESS.hasGates('premium_enterprise'),
    path: '/automation',
  },
]

export default SUB_NAV_NODES



// WEBPACK FOOTER //
// ./src/scripts/components/PlaybookList/navigation.js